import { ExportButton } from "app/components/ExportButton";
import {
  List,
  Datagrid,
  TextField,
  Create,
  SimpleForm,
  TextInput,
  required,
  Edit,
  TopToolbar,
  SaveButton,
  DeleteButton,
  DateField,
  SimpleShowLayout,
  useNotify,
  FileField,
  FileInput,
  FormTab,
  TabbedForm,
  FilterButton,
  SelectInput,
  CreateButton,
} from "react-admin";

export class DeviceModelUpdateCommand {
  private name: string;
  private type: string;

  constructor(data: any) {
    this.name = data.name ?? "";
    this.type = data.type;
  }

  static fromJson(data: any) {
    return new DeviceModelUpdateCommand(data);
  }
}

const DeviceTypes = [
  { id: "Addon", name: "Addon" },
  { id: "SmartIO", name: "SmartIO" },
];

const ListFilters = [
  <TextInput source="id" />,
  <TextInput source="model" />,
  <SelectInput source="type" choices={DeviceTypes} />,
];

export const DeviceModelList = () => (
  <List
    filters={ListFilters}
    actions={
      <TopToolbar>
        <FilterButton />
        <CreateButton />
        <ExportButton resource="devices/models" />
      </TopToolbar>
    }
  >
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <DateField source="createdAt" showTime />
      <TextField source="name" />
      <TextField source="type" />
    </Datagrid>
  </List>
);

const validateCreation = (values: any) => {
  const errors: any = {};

  if (values.file) {
    return errors;
  }
  if (!values.name) {
    errors.name = "Required";
  }

  if (!values.type) {
    errors.type = "Required";
  }

  return errors;
};

export const DeviceModelCreate = () => {
  const notify = useNotify();
  const onError = (error?: any) => {
    notify(
      `Could not create client: ${
        error?.response?.data?.title ?? error?.message
      }`,
      { type: "error" }
    );
  };

  return (
    <Create mutationOptions={{ onError }} redirect="list">
      <TabbedForm validate={validateCreation}>
        <FormTab label="single">
          <TextInput source="name" validate={required()} />
          <SelectInput
            source="type"
            choices={DeviceTypes}
            validate={required()}
          />
        </FormTab>

        <FormTab label="file">
          <FileInput
            source="file"
            label="CSV (name*,type*)"
            accept="text/csv"
            multiple={false}
          >
            <FileField source="src" title="title" />
          </FileInput>
        </FormTab>
      </TabbedForm>
    </Create>
  );
};

const EditActions = () => (
  <TopToolbar>
    <SaveButton />
    <DeleteButton />
  </TopToolbar>
);

export const DeviceModelEdit = () => (
  <Edit>
    <SimpleForm toolbar={<EditActions />}>
      <SimpleShowLayout>
        <TextField source="id" />
        <DateField source="createdAt" showTime />
      </SimpleShowLayout>
      <TextInput source="name" validate={required()} />
      <SelectInput source="type" choices={DeviceTypes} validate={required()} />
    </SimpleForm>
  </Edit>
);
